<template>
    <div class="flex gap-2 h-full">
    <div class="w-1/2 flex flex-col gap-2 px-2">
      <div class="flex flex-col text-start h-full">
        <textarea
          name=""
          id=""
          cols="30"
          rows="20"
          v-model="content"
          class="form-control block px-3 py-1 text-sm font-normal text-gray-700 bg-white bg-clip-padding focus:ring-0 focus:border-primary border-[#e5e7eb] rounded shadow-md focus:outline-none w-full h-full"
        ></textarea>
      </div>
    </div>
    <div class="h-full">
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            content: `<table align="center" style="margin:auto; width:600px;background-color: white;border:solid 1px #D1D5DB;">
        <tr>
            <td>
                <table style="border-collapse: collapse;width: 100%;">
                    <tr>
                        <td style="padding:20px">
                            <img src="https://demo.api.maggana.com/media/email/email05/headlogo.png" style="width:200px;">
                        </td>
                    </tr>
                    <tr style="background-color: #face4b;">
                        <td>
                            <div style="padding-top:40px;padding-left:30px;">
                                <span style="font-size: 35px;font-weight:bold">Scholarship<br>Extension
                                    Alert!</span><br>

                                <span style="font-size: 15px;font-weight:normal;">*Valid for 5 days only</span>
                            </div>

                            <p style="margin-top: 25px;margin-left:24px">
                                <a href="https://lots.learn.online/" target="_blank">
                                    <button
                                        style="padding: 8px 13px;background-color:#231f20;border-radius: 10px;color:white;
                                                                text-align: center;font-weight: bold;border-radius: 30px;font-size: 14px;cursor: pointer;">
                                        CHOOSE UNIVERSITY & PROGRAM
                                    </button>
                                </a>
                            </p>

                        </td>
                        <td>
                            <img src="https://demo.api.maggana.com/media/email/email05/bg1.png" style="width:250px">
                        </td>
                    </tr>
                </table>
            </td>
        </tr>

        <tr>
            <td style="padding: 5px 0px;">
                <div style="padding-left:20px;padding-top:10px;font-weight: 500;font-size: 15px;">
                    <p>Hello {{ name }} ,</p>
                    <p>Good news!!!</p>
                    <p>Your _% scholarship has been extended! Don't miss out on availing it and signing up for a program
                        and
                        University of your choice.</p>
                    <p>Hurry up!</p>
                </div>

                <p style="text-align: center;padding-bottom: 10px;">
                    <a href="https://lots.learn.online/" target="_blank">
                        <button
                            style="padding: 8px 13px;background-color:#231f20;border-radius: 10px;color:white;
                                                                                                    text-align: center;font-weight: bold;border-radius: 30px;font-size: 14px;cursor: pointer;">
                            CHOOSE UNIVERSITY & PROGRAM
                        </button>
                    </a>
                </p>
            </td>
        </tr>

        <tr>
            <td>
                <table style="border-collapse: collapse;width: 100%;">
                    <tr style="background-color: #face4b;padding: 0px 10px;text-align: center;">
                        <td style=" width: calc(600px / 3);font-size:15px;padding: 5px 0px;">
                            <div style="vertical-align: middle;border-right:1px solid black;font-weight: 500;"><a
                                    href="tel:+917005997005" style="text-decoration:none;color:black"><img
                                        src="https://demo.api.maggana.com/media/email/email05/call.png" style="width: 20px;vertical-align: middle;padding:5px;">+91 70059
                                    97005</a>
                            </div>
                        </td>
                        <td style=" width: calc(600px / 3);font-size:15px;padding: 5px 0px;">
                            <div style="vertical-align: middle;border-right:1px solid black;font-weight: 500;"><a
                                    href="https://lots.learn.online/" style="text-decoration:none;color:black"><img
                                        src="https://demo.api.maggana.com/media/email/email05/globe.png"
                                        style="width: 20px;vertical-align: middle;padding:5px;">www.lots.learn.online</a>
                            </div>
                        </td>
                        <td style=" width: calc(600px / 3);font-size:15px;padding: 5px 0px;font-weight: 500;">
                            <div style="vertical-align: middle;"><a href="mailto:info@learn.online"
                                    style="text-decoration:none;color:black"><img src="https://demo.api.maggana.com/media/email/email05/email.png"
                                        style="width: 20px;vertical-align: middle;padding:5px;">info@learn.online</a>
                            </div>
                        </td>

                    </tr>
                </table>
            </td>
        </tr>
    </table>`
        }
    }
}
</script>

<style>

</style>